<template>
	<ul>
		<user-images-list-item v-for="user in users" :user="user" :key="user.userID || user.objectID"></user-images-list-item>
	</ul>
</template>

<script>
import UserImagesListItem from "./UserImagesListItem.vue";

export default {
	props: {
		users: {
			type: Array
		}
	},
	components: {
		UserImagesListItem
	}
};
</script>

<style scoped>
ul {
	/* margin-top: 5px; */
	display: inline-flex;
}

ul li:not(:first-of-type) {
	margin-left: -20px;
}
</style>



// WEBPACK FOOTER //
// src/components/users/userLists/UserImagesList.vue